import StatesList from './StaticStatesList.json';
import CountiesList from './StaticCountiesList.json';
import { SCRIPT_URL } from '../controller/ScriptUrl';

const localDevelopment = (() => {
    const localurl = 'http://localhost';
    var h = window.location.origin || localurl; //fallback for local testing
    return h.substring(0, 16) === localurl;
})();
const debugMode = Boolean(window.location.search === '?debug=direct');
const statesList = Array.isArray(StatesList) ? StatesList : Object.values(StatesList);
const countiesList = Array.isArray(CountiesList) ? CountiesList : Object.values(CountiesList);

const PUBLIC_URL = process.env?.PUBLIC_URL;
export { PUBLIC_URL };

const DATA_URL = process.env?.REACT_APP_DATA_URL?.trim() || SCRIPT_URL + '/data';
export { DATA_URL };

export { SCRIPT_URL };

const scopeList = ['national', 'state'];

const tractList = ['county', 'census'];

const minCensusZoom = 8;

const staticYearList = [
    { id: 5, label: 2020, columns: '2020', localdoc: 'SVI2020Documentation_08.05.22.pdf', varpage: 7, docs: '/placeandhealth/svi/map/data/docs/SVI2020Documentation_08.05.22.pdf', filename: 'svi_2020_Documentation.pdf' },
    { id: 4, label: 2018, columns: 'before2020', localdoc: 'SVI2018Documentation_01192022_1.pdf', varpage: 6, docs: 'https://www.atsdr.cdc.gov/placeandhealth/svi/documentation/pdf/SVI2018Documentation_01192022_1.pdf', filename: 'svi_2018_Documentation.pdf' },
    { id: 3, label: 2016, columns: 'before2020', localdoc: 'SVI2016Documentation_01192022.pdf', varpage: 5, docs: 'https://www.atsdr.cdc.gov/placeandhealth/svi/documentation/pdf/SVI2016Documentation_01192022.pdf', filename: 'svi_2016_Documentation.pdf' },
    { id: 2, label: 2014, columns: 'before2020', localdoc: 'SVI2014Documentation_01192022.pdf', varpage: 5, docs: 'https://www.atsdr.cdc.gov/placeandhealth/svi/documentation/pdf/SVI2014Documentation_01192022".pdf', filename: 'svi_2014_Documentation.pdf' },
    { id: 1, label: 2010, columns: 'before2020', localdoc: 'SVI-2010-Documentation-H.pdf', varpage: 2, docs: 'https://www.atsdr.cdc.gov/placeandhealth/svi/documentation/pdf/SVI-2010-Documentation-H.pdf', filename: 'svi_2010_Documentation.pdf' },
    { id: 0, label: 2000, columns: 'before2020', localdoc: 'SVI2000Documentation-H.pdf', varpage: 2, docs: 'https://www.atsdr.cdc.gov/placeandhealth/svi/documentation/pdf/SVI2000Documentation-H.pdf', filename: 'svi_2000_Documentation.pdf' }
];
// [-8963431.22589316, 4711436.653467792, -7452829.01045942, 6017435.399903431]
const staticRegions = [
    { id: 90, label: 'North East', slug: 'north', states: ['CT', 'ME', 'MA', 'NH', 'RI', 'VT', 'NJ', 'NY', 'PA'], bounds: [-8963431.22589316, 4711436.653467792, -7452829.01045942, 6017435.399903431] },
    { id: 91, label: 'Midwest', slug: 'midwest', states: ['IA', 'IL', 'MI', 'OH', 'WI', 'IN', 'KS', 'MN', 'MO', 'NE', 'ND', 'SD'], bounds: [-11583671.057132892, 4300030.803637005, -8963298.449877389, 6340327.948480618] },
    { id: 92, label: 'South', slug: 'south', states: ['DE', 'DC', 'FL', 'GA', 'MD', 'NC', 'SC', 'VA', 'WV', 'AL', 'KY', 'MS', 'TN', 'AR', 'LA', 'OK', 'TX'], bounds: [-11871738.107350338, 2817279.165905216, -8354406.609551439, 4959208.80562331] },
    { id: 93, label: 'West', slug: 'west', states: ['AZ', 'CO', 'ID', 'NM', 'MT', 'UT', 'NV', 'WY', 'AK', 'CA', 'HI', 'OR', 'WA'], bounds: [-13888558.366914133, 3675966.7275074017, -11359213.202471135, 6275282.0832699165] },
    { id: 101, label: 'HHS Region 1', slug: 'hhs_1', bounds: [-8207048.885487032, 5012035.78267602, -7454920.732438947, 6016392.843228203] },
    { id: 102, label: 'HHS Region 2', slug: 'hhs_2', bounds: [-8879202.748137256, 4715458.061657053, -8000410.112031289, 5622432.644064123] },
    { id: 103, label: 'HHS Region 3', slug: 'hhs_3', bounds: [-9314669.693540633, 4375378.482643267, -8315453.342702627, 5201183.892387872] },
    { id: 104, label: 'HHS Region 4', slug: 'hhs_4', bounds: [-10201783.354081057, 2870403.981349898, -8399819.28488534, 4742074.857426927] },
    { id: 105, label: 'HHS Region 5', slug: 'hhs_5', bounds: [-10823548.790989276, 4437201.018921441, -8963337.550752344, 6338102.318433109] },
    { id: 106, label: 'HHS Region 6', slug: 'hhs_6', bounds: [-12139657.48903961, 2980058.997398602, -9909854.080172105, 4439285.342256802] },
    { id: 107, label: 'HHS Region 7', slug: 'hhs_7', bounds: [-11583535.68933657, 4299155.480271736, -9919099.662877059, 5388633.782217532] },
    { id: 108, label: 'HHS Region 8', slug: 'hhs_8', bounds: [-12920215.80890543, 4437548.37768374, -10735715.755292203, 6274851.243617513] },
    { id: 109, label: 'HHS Region 9', slug: 'hhs_9', bounds: [-17838403.528806202, 2146081.977474044, -12138964.070336737, 5161336.555302727] },
    { id: 110, label: 'HHS Region 10', slug: 'hhs_10', bounds: [-19839378.76572607, 5159096.592124039, -12361782.61352615, 11542482.88598487] }
];
/*
north:
========
-86.6162109, 47.4610385
-59.4873083, 47.4610385
-59.4873083, 37.2303284
-86.6162109, 37.2303284
-86.6162109, 47.4610385

midwest:
=======
-115.6640598, 46.9238494
-89.7656259, 46.9238494
-89.7656259, 36.3239001
-115.6640598, 36.3239001

south
======
-110.8740261, 37.9396502
-86.1767605, 37.9396502
-86.1767605, 26.0247440
-110.8740261, 26.0247440

west
======
-115.6640598, 46.9238494
-89.7656259, 46.9238494
-89.7656259, 36.3239001
-115.6640598, 36.3239001
*/
const tabList = [
    { id: 0, label: 'Map', slug: 'map', icon: 'map' },
    { id: 1, label: 'Table', slug: 'data', icon: 'table' },
    { id: 2, label: 'More', slug: 'info', icon: 'info' },
    { id: 3, label: 'Details', slug: 'details', close: true, hidden: true }
];

const staticPOIList = [
    { id: 0, label: 'Streets & Roads', slug: 'streetmap', icon: 'map-signs' },
    { id: 1, label: 'HHS Regions', slug: 'hhsregion', icon: 'road' },
    { id: 2, label: 'Nursing Home', slug: 'nursinghome', icon: 'hand-holding-heart', color: '#b78907', textColor: '#000', offset: 'left', blacklist: [] },
    { id: 3, label: 'Hospital', slug: 'hospital', icon: 'building', color: '#2b5ddf', textColor: '#fff', offset: 'top', blacklist: [] },
    { id: 4, label: 'Daycare Center', slug: 'daycare', icon: 'baby', color: '#b76fb0', textColor: '#000', offset: 'right', blacklist: [] },
    { id: 5, label: 'Public School', slug: 'school', icon: 'school', color: '#db1325', textColor: '#fff', offset: 'bottom', blacklist: [37422] }
];

const mercator = 'EPSG:3857'; //https://epsg.io/3857
const latlon = 'EPSG:4326'; //https://epsg.io/4326

const dataProjection = 'EPSG:4326';
const featureProjection = 'EPSG:3857';

const app_coordinates = {
    worldCenter: [0, 0],
    usCenter4326: [-98.5789045063735, 39.85508149128133],
    usCenter3857: [-10973753.45260824, 4844905.410136566]
};
//left,bottom,right,top
const app_extents = {
    contiguous_us_and_pr: [-14150703.25072198, 1724460.655959669, -7075872.59319234, 6815350.164313462], //mercator
    max_map_bounds: [-28150703.25072198, -80000.1396078935, 339584.7237982075, 12446275.841017159] //mercator
};

const mapStaticVariables = {
    extents: app_extents,
    coordinates: app_coordinates,
    projections: { mercator, latlon }
};
export { mapStaticVariables };

export { localDevelopment, debugMode, staticPOIList, scopeList, tractList, countiesList, staticYearList, staticRegions, statesList, tabList, dataProjection, featureProjection, minCensusZoom };

const getState = (fips) => {
    let stateFips = String(fips).substring(0, 2);
    return statesList.find((st) => st.id === stateFips);
};
const getStateName = (fips) => {
    let state = getState(fips);
    return state?.label || '';
};
export { getState, getStateName };

const getCounty = (fips) => {
    let countyFips = String(fips).substring(0, 5);
    return countiesList.find((cnt) => cnt.cc + '' == countyFips || cnt.CC + '' == countyFips);
};
const getCountyName = (fips) => {
    let county = getCounty(fips);
    return county?.CN || '';
};
export { getCounty, getCountyName };
